<template>
  <div class="principaleContent">
    <div :class="drawer == 'big' ? 'lefBar' : 'lefBarMini'">
      <div class="logoContent">
        <img src="../assets/logo.png" class="logoImg" alt="John" />
        <!-- <img src="https://i.ibb.co/h1HbWPn/d.png" class="logoImg" alt="" /> -->
        <!-- <span v-show="drawer == 'big'">ABIAPHAR</span> -->
      </div>
      <div class="contentListe monElement">
        <div v-for="element in items" :key="element.title" class="menueGroupe">
          <div
            v-if="element.title == UserProfile.role"
            v-show="drawer == 'big'"
            class="titleMenue"
          >
            <span>{{ element.title }}</span>
          </div>
          <ul v-if="element.title == UserProfile.role">
            <!-- <li class="active">
                <div class="myContent">
                  <span class="menueIcone material-icons-sharp"> home </span>
                  <span class="menueText">Tableau de bord</span>
                </div>
              </li> -->
            <li
              v-for="child in element.item"
              :key="child.text"
              :class="child.route === routeActuelle ? 'active' : 'no'"
              @click="redirectToRoute(child.route)"
            >
              <div class="myContent">
                <span class="menueIcone material-icons-sharp">
                  {{ child.icon }}
                </span>
                <span v-show="drawer == 'big'" class="menueText">{{
                  child.text
                }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div :class="drawer == 'big' ? 'centerContent' : 'centerContentMini'">
      <div class="headerNavBar">
        <div class="leftContent">
          <div @click="changeConteneurView" class="togleMenueButton">
            <span v-if="drawer == 'big'" class="material-icons-sharp">
              chevron_left
            </span>
            <span v-else class="material-icons-sharp"> chevron_right </span>
          </div>
          <div @click="updateColors" class="togleMenueButton hide">
            <span v-if="pageColor == 'moon'" class="material-icons-sharp">
              dark_mode
            </span>
            <span v-else class="material-icons-sharp"> light_mode </span>
          </div>
          <div @click="modifierTaille" class="notificationCount">
            <span class="material-icons-sharp"> notifications_none </span>
            <span class="patch">-</span>
          </div>
          <div @click="openDocumentation" class="togleMenueButton" title="Manuel d'utilisation">
            <span class="material-icons-sharp"> menu_book </span>
          </div>
        </div>
        <div class="rightContent">
          <div class="profileTexte">
            <span class="userName">{{
              UserProfile.fullName + " ( " + UserProfile.role + " )"
            }}</span>
            <span>{{
              UserProfile.wallets && UserProfile.wallets.paymentMethods && UserProfile.wallets.paymentMethods.length >= 5
                ? "Portefeuille : " +
                  UserProfile.wallets.paymentMethods[0].balance +
                  " FCFA || Espèce : " +
                  UserProfile.wallets.paymentMethods[1].balance +
                  " FCFA || Crédit : " +
                  UserProfile.wallets.paymentMethods[2].balance +
                  " FCFA || Chèque : " +
                  UserProfile.wallets.paymentMethods[3].balance +
                  " FCFA || Virement : " +
                  UserProfile.wallets.paymentMethods[4].balance
                : "Solde actuel de votre compte " + "0 FCFA"
            }}</span>
          </div>
          <img src="../assets/profile.png" alt="" />
          <div @click="logoutMethods" class="buttonLogout">
            <span>Se déconnecter</span>
          </div>
        </div>
      </div>
      <router-view
        @closeAllModal="closeModal"
        @editeRowForDash="modifierTaille"
        @show="showLoading"
        :value="myAnotherValue"
      />
    </div>
    <div class="totalContent">
      <div class="fileForm">
        <div class="input-section">
          <label> Total vente <span class="required-color">*</span> </label>
          <input
            type="number"
            disabled
            class="disabled"
            v-model="amount"
            placeholder="Total vente"
            required
          />
        </div>
      </div>
    </div>
    <div class="modaleContent">
      <div class="buttonRow">
        <div @click="closeModal" class="closeModalButton">
          <span class="material-icons-sharp"> close </span>
        </div>
        <!-- <div @click="closeModal" class="closeModalButton">
          <span class="material-icons-sharp"> delete </span>
        </div> -->
      </div>

      <div v-show="modalIsOpen" class="modal">
        <FormComponent
          @closeAllModal="closeModal"
          @closeAllModalForSecond="closeModalSecond"
          :value="formValue"
          @editeRowForDash="modifierTailleSecond"
          @show="showLoading"
          @calculeTotal="makecalculeTotal"
          @statEmitValue="emitValueToStatInterface"
        />
      </div>
    </div>
    <div class="modaleContentSecond">
      <div @click="closeModalSecond" class="closeModalButton">
        <span class="material-icons-sharp"> close </span>
      </div>
      <div v-show="modalSecondIsOpen" class="modal">
         <v-main>
        <FormulaireSecond
          @closeAllModal="closeModalSecond"
          :value="formValueSecond"
          @editeRowForDash="modifierTailleSecond"
          @show="showLoading"
        />
         </v-main>

      </div>
    </div>
    <v-dialog
      v-model="loading"
      overlay-color="#e9ae53"
      persistent
      width="500"
      elevation="0"
    >
      <div class="preloader">
        <svg
          class="cart"
          role="img"
          aria-label="Shopping cart line animation"
          viewBox="0 0 128 128"
          width="128px"
          height="128px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="8"
          >
            <g class="cart__track" stroke="hsla(0,10%,10%,0.1)">
              <polyline
                points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80"
              />
              <circle cx="43" cy="111" r="13" />
              <circle cx="102" cy="111" r="13" />
            </g>
            <g class="cart__lines" stroke="currentColor">
              <polyline
                class="cart__top"
                points="4,4 21,4 26,22 124,22 112,64 35,64 39,80 106,80"
                stroke-dasharray="338 338"
                stroke-dashoffset="-338"
              />
              <g class="cart__wheel1" transform="rotate(-90,43,111)">
                <circle
                  class="cart__wheel-stroke"
                  cx="43"
                  cy="111"
                  r="13"
                  stroke-dasharray="81.68 81.68"
                  stroke-dashoffset="81.68"
                />
              </g>
              <g class="cart__wheel2" transform="rotate(90,102,111)">
                <circle
                  class="cart__wheel-stroke"
                  cx="102"
                  cy="111"
                  r="13"
                  stroke-dasharray="81.68 81.68"
                  stroke-dashoffset="81.68"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </v-dialog>
    <v-dialog
      :persistent="updateYourProfileNow"
      v-model="updateProfile"
      max-width="1000px"
    >
      <v-card style="border-top: 10px solid #ffc221">
        <div class="QcmModale">
          <div class="modal">
            <div class="form">
              <h4 class="mt-5">Informations de vérification</h4>
              <!-- <div class="ml-3 logoInssured">
                <img
                  v-if="idPicture"
                  style="border-radius: 100%; width: 100px; height: 100px"
                  :src="idPicture"
                />
                <img v-else src="../assets/profile.png" />
              </div> -->
              <!-- <div class="ml-3 partOf">
                <input
                  type="file"
                  ref="fileInput"
                  style="display: none"
                  @change="handleFileChange"
                  accept="image/*"
                />
                <v-btn
                  @click="selectProfilePicture"
                  class="mb-10  "
                >
                  cliquer pour changer la photo de profile
                </v-btn>
              </div> -->
              <div class="mb-5 fileFormProfile">
                <div class="input-section">
                  <label>Nom <span class="required-color">*</span></label>
                  <input
                    type="text"
                    placeholder="Nom"
                    v-model="profileData.fullName"
                    id="fullname-input"
                    required
                  />
                </div>

                <!-- <div class="input-section">
                  <label
                    >Numéro de télephone
                    <span class="required-color">*</span></label
                  >
                  <input
                    type="text"
                    placeholder="Numéro de télephone"
                    v-model="profileData.phone"
                    id="first-name-input"
                    required
                  />
                </div> -->
                <div class="input-section">
                  <label>Mail <span class="required-color">*</span></label>
                  <input
                    type="text"
                    placeholder="Mail"
                    disabled
                    class="isDisabled"
                    v-model="profileData.email"
                    id="email-input"
                    required
                  />
                </div>
                <div class="input-section">
                  <label
                    >Ancien mot de passe
                    <span class="required-color">*</span></label
                  >
                  <input
                    type="password"
                    placeholder="Ancien mot de passe"
                    v-model="profileData.oldPassword"
                    id="old-password-input"
                    required
                  />
                </div>
              </div>

              <div class="mb-5 fileFormProfile">
 
                <div class="input-section">
                  <label
                    >Nouveau mot de passe
                    <span class="required-color">*</span></label
                  >
                  <input
                    type="password"
                    placeholder="Nouveau mot de passe"
                    v-model="profileData.newPassword"
                    id="new-password-input"
                    required
                  />
                </div>
                <div class="input-section">
                  <label
                    >confirmer Nouveau mot de passe
                    <span class="required-color">*</span></label
                  >
                  <input
                    type="password"
                    placeholder="confirmer Nouveau mot de passe"
                    v-model="profileData.password"
                    id="confirm-password-input"
                    required
                  />
                </div>
              </div>

              <v-card-actions>
                <div class="partOf">
                  <v-btn
                    v-if="!updateYourProfileNow"
                    class="buttonFormOne"
                    @click="updateProfile = false"
                  >
                    Fermer
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn
                    class="buttonDone"
                    @click="onUpdatedUserProfile()"
                  >
                    Modifier mon profile
                  </v-btn>
                </div>
              </v-card-actions>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
    
    <script>
import FormComponent from "../components/Formulaire.vue";
import FormulaireSecond from "../components/FormulaireSecond.vue";
import { mapActions, mapGetters } from "vuex";
import { logout, updateUserProfile } from "@/api/user";
import { defaultMethods, messages } from "../utils/data";

export default {
  name: "dashboardView",
  components: {
    FormComponent,
    FormulaireSecond,
  },
  data: () => ({
    drawer: "big",
    routeActuelle: "",
    pageColor: "sun",
    colorForced: false,
    modalIsOpen: false,
    amount: 0,
    formValue: {},
    loading: false,
    formValueSecond: {},
    modalSecondIsOpen: false,
    updateProfile: false,
    updateYourProfileNow: false,
    profileData: {},
    myAnotherValue: {},
    items: [
      {
        title: "Caisse",
        item: [
          {
            icon: "home",
            text: "Tableau de bord",
            route: "/",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "person_outline",
            text: "Gestion clients",
            route: "/client",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "grading",
            text: "Bon de commande",
            route: "/commande",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "point_of_sale",
            text: "Caisse",
            route: "/caisse",
            isAdmin: true,
            isUser: true,
          },
        ],
      },
      {
        title: "Responsable financier",
        item: [
          {
            icon: "home",
            text: "Tableau de bord",
            route: "/",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "construction",
            text: "Paramètrages",
            route: "/parameters",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "account_balance_wallet",
            text: "Comptabilité",
            route: "/comptabilite",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "grading",
            text: "Bon de commande",
            route: "/commande",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "point_of_sale",
            text: "Caisse",
            route: "/caisse",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "rule",
            text: "Produit déficit",
            route: "/missed",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "receipt_long",
            text: "Inventaire",
            route: "/inventaire",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "reduce_capacity",
            text: "Bonus de fidélité",
            route: "/reduction",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "person_outline",
            text: "Gestion clients",
            route: "/client",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "low_priority",
            text: "Retour produit",
            route: "/retour",
            isAdmin: true,
            isUser: true,
          },
        ],
      },
      {
        title: "Magasinier",
        item: [
          {
            icon: "home",
            text: "Tableau de bord",
            route: "/",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "inventory",
            text: "Entrée de stock",
            route: "/entrer",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "storefront",
            text: "Sortie de stock",
            route: "/sortie",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "receipt_long",
            text: "Inventaire",
            route: "/inventaire",
            isAdmin: true,
            isUser: true,
          },
        ],
      },
      {
        title: "Accueil",
        item: [
          {
            icon: "home",
            text: "Tableau de bord",
            route: "/",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "person_outline",
            text: "Gestion clients",
            route: "/client",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "grading",
            text: "Bon de commande",
            route: "/commande",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "low_priority",
            text: "Retour produit",
            route: "/retour",
            isAdmin: true,
            isUser: true,
          },
        ],
      },
      {
        title: "Contrôleur",
        item: [
          {
            icon: "home",
            text: "Tableau de bord",
            route: "/",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "rule",
            text: "Produit déficit",
            route: "/missed",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "inventory",
            text: "Entrée de stock",
            route: "/entrer",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "storefront",
            text: "Sortie de stock",
            route: "/sortie",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "receipt_long",
            text: "Inventaire",
            route: "/inventaire",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "low_priority",
            text: "Retour produit",
            route: "/retour",
            isAdmin: true,
            isUser: true,
          },
        ],
      },
      {
        title: "Responsable des opérations",
        item: [
          {
            icon: "home",
            text: "Tableau de bord",
            route: "/",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "production_quantity_limits",
            text: "Approvisionnement",
            route: "/approvisionnement",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "construction",
            text: "Paramètrages",
            route: "/parameters",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "person_outline",
            text: "Gestion clients",
            route: "/client",
            isAdmin: true,
            isUser: true,
          },
        ],
      },
      {
        title: "Administrateur",
        item: [
          {
            icon: "home",
            text: "Tableau de bord",
            route: "/",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "production_quantity_limits",
            text: "Approvisionnement",
            route: "/approvisionnement",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "warehouse",
            text: "Stocks",
            route: "/stock",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "construction",
            text: "Paramètrages",
            route: "/parameters",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "payments",
            text: "Sortie d'argent",
            route: "/sortie_argent",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "reduce_capacity",
            text: "Bonus de fidélité ",
            route: "/reduction",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "price_check",
            text: "Tracking",
            route: "/estimation",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "trending_up",
            text: "Statistiques",
            route: "/statistiques",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "rule",
            text: "Produit déficit",
            route: "/missed",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "inventory",
            text: "Entrée de stock",
            route: "/entrer",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "storefront",
            text: "Sortie de stock",
            route: "/sortie",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "receipt_long",
            text: "Inventaire",
            route: "/inventaire",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "person_outline",
            text: "Gestion clients",
            route: "/client",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "grading",
            text: "Bon de commande",
            route: "/commande",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "low_priority",
            text: "Retour produit",
            route: "/retour",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "point_of_sale",
            text: "Caisse",
            route: "/caisse",
            isAdmin: true,
            isUser: true,
          },
          {
            icon: "account_balance_wallet",
            text: "Comptabilité",
            route: "/comptabilite",
            isAdmin: true,
            isUser: true,
          },
        ],
      },
    ],
  }),
  computed: {
    ...mapGetters(["UserProfile"]),

    isUser() {
      if (localStorage.getItem("user-token")) return true;
      return false;
    },
    profile() {
      if (this.UserProfile && this.UserProfile._id) return this.UserProfile;
      else return this.AdminProfile;
    },
  },
  mounted() {
    this.routeActuelle = this.$route.path;
    // setInterval(() => {
    //   if (!this.colorForced) {
    //     this.determinePageColor();
    //   }
    // }, 6000);
    this.changeConteneurView();
    this.initFiles();
  },

  methods: {
    ...mapActions(["getUserProfile"]),
    async initFiles() {
      await this.getUserProfile();
      console.log("Profile", this.UserProfile);

      if (!this.UserProfile.alreadyChangeDefaultPassword) {
        this.updateYourProfileNow = true;
        this.profileData.fullName = this.UserProfile.fullName;
        this.profileData.email = this.UserProfile.email;
        this.profileData._id = this.UserProfile._id;
        this.updateProfile = true;
      }


      
      // defaultMethods.dispatchError(
      //     this.$store,
      //     messages.failedToLoad("les dossiers")
      //   );
    },
    logoutMethods() {
      logout();
    },
    openDocumentation() {
      this.$router.push('/documentation');
    },
    emitValueToStatInterface(item) {
      this.myAnotherValue = Object.assign({}, item);
      // alert(JSON.stringify(item))
      this.$forceUpdate();
    },
    changeConteneurView() {
      if (this.drawer == "big") {
        this.drawer = "mini";
      } else {
        this.drawer = "big";
      }
    },
    determinePageColor() {
      // Obtenir l'heure actuelle
      var now = new Date();
      var currentHour = now.getHours();

      // Vérifier si l'heure est entre 6h et 19h
      if (currentHour >= 6 && currentHour < 19) {
        // C'est le jour
        this.pageColor = "sun";
        document.documentElement.style.setProperty("--color-white", "#fff");
        document.documentElement.style.setProperty(
          "--color-background",
          "#f5f5f9"
        );
        document.documentElement.style.setProperty("--color-dark", "#363949");
      } else {
        // C'est la nuit
        this.pageColor = "moon";
        document.documentElement.style.setProperty("--color-white", "#363949");
        document.documentElement.style.setProperty(
          "--color-background",
          "#677483"
        );
        document.documentElement.style.setProperty("--color-dark", "#f5f5f9");
      }
    },
    showLoading(item) {
      this.loading = item;
    },
    makecalculeTotal(item) {
      this.amount = 0;
      this.amount = item;
    },
    modifierTailleSecond(item) {
      // alert("ok")
      var modaleContentSecond = document.querySelector(".modaleContentSecond");
      if (modaleContentSecond) {
        modaleContentSecond.style.width = item.size + "px";
        this.formValueSecond = item.value;
        // alert(JSON.stringify(this.formValueSecond))
      }
      this.modalSecondIsOpen = true;
    },
    modifierTaille(item) {
      var modaleContent = document.querySelector(".modaleContent");
      var totalContent = document.querySelector(".totalContent");
      if (modaleContent) {
        // Modifier d'abord la largeur de modaleContent
        modaleContent.style.width = item.size + "px";
        this.formValue = item.value;

        // Utiliser setTimeout pour permettre à la modification de la largeur de prendre effet
        setTimeout(() => {
          // Récupérer la largeur de modaleContent
          const modalWidth = item.size;

          // Définir le nombre d'éléments par ligne en fonction de la largeur
          let columns;
          if (modalWidth <= 300) {
            columns = 1;
          } else if (modalWidth <= 500) {
            columns = 2;
          } else if (modalWidth <= 800) {
            columns = 3;
          } else if (modalWidth > 800) {
            columns = 4;
          }

          // Appliquer le nombre d'éléments par ligne au grid
          const fileForm = document.querySelector(".fileForm");
          const fileFormSecond = document.querySelector(".fileFormSecond");
          if (fileForm && modalWidth <= 300) {
            fileForm.style.gridTemplateColumns = `repeat(1, 1fr)`;
            // alert(JSON.stringify(fileForm.style))
          }
          if (fileFormSecond && modalWidth > 300) {
            fileFormSecond.style.gridTemplateColumns = `repeat(${
              columns - 1
            }, 1fr)`;
          }
          if (item.name == "customerCommande" && totalContent) {
            totalContent.style.display = "flex";
            totalContent.style.opacity = 1;
          } else {
            totalContent.style.display = "none";
            totalContent.style.opacity = 0;
          }
        }, 0);
      }
      this.modalIsOpen = true;
    },
    closeModalSecond() {
      this.modalSecondIsOpen = false;
      var modaleContentSecond = document.querySelector(".modaleContentSecond");

      if (modaleContentSecond) {
        modaleContentSecond.style.width = "0px";
      }
    },
    async onUpdatedUserProfile() {
      this.loading = true;
      try {
        let schema = {
          fullName: this.profileData.fullName,
          email: this.profileData.email,
        };

        // Check if the passwords match before updating
        if (this.profileData.password === this.profileData.newPassword) {
          schema.oldPassword = this.profileData.oldPassword;
          schema.password = this.profileData.password;
        } else {
          defaultMethods.dispatchError(
            this.$store,
            "Mot de passe non conforme"
          );
          this.loading = false; // Set loading to false here
          return; // Exit the function early if the password doesn't match
        }

        await updateUserProfile({
          schema,
          // id: this.profileData._id,
        });

        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("L'utilisateur")
        );
        this.loading = false; // Set loading to false after successful update
        this.logoutMethods();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          "Une erreur est survenue lors de la mise à jour de votre profil. Si le problème persiste, veuillez contacter l'administrateur."
        );
        this.loading = false; // Set loading to false in case of error
      }
    },
    closeModal() {
      this.modalIsOpen = false;
      var totalContent = document.querySelector(".totalContent");
      var modaleContent = document.querySelector(".modaleContent");
      if (totalContent) {
        totalContent.style.display = "none";
      }
      if (modaleContent) {
        modaleContent.style.width = "0px";
      }
      this.closeModalSecond();
    },
    updateColors() {
      this.colorForced = true;
      if (this.pageColor == "sun") {
        this.pageColor = "moon";
        document.documentElement.style.setProperty("--color-white", "#363949");
        document.documentElement.style.setProperty(
          "--color-background",
          "#677483"
        );
        document.documentElement.style.setProperty("--color-dark", "#f5f5f9");
      } else {
        this.pageColor = "sun";
        document.documentElement.style.setProperty("--color-white", "#fff");
        document.documentElement.style.setProperty(
          "--color-background",
          "#f5f5f9"
        );
        document.documentElement.style.setProperty("--color-dark", "#363949");
      }
    },
    generrateColors() {
      const randomColor = () =>
        "#" + Math.floor(Math.random() * 16777215).toString(16);

      const colors = [];
      for (let i = 0; i < this.chartData.series.length; i++) {
        colors.push(randomColor());
      }
      console.log(colors);
      this.chartData.options.fill.colors = colors;
    },
    redirectToRoute(route) {
      this.$router.push(route);
      this.routeActuelle = this.$route.path;
    },
  },
};
</script>
    
    <style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap");
.monElement {
  overflow: auto; /* ou scroll si nécessaire */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer/Edge */
}

.monElement::-webkit-scrollbar {
  display: none !important; /* Chrome, Safari, Opera */
}
body {
  margin: 0px;
}
:root {
  --color-primary: #e9ae53;
  --color-primary-solve: #e9ae5329;
  --color-primary-hard: #916c3a;
  --color-danger: #0482fb;
  --color-primary-hard: #916c3a;
  --color-success: #517f98;
  --color-success-dark: #347013;
  --color-green-white: #e6f9e1;
  --color-blue: #9ae7f8;
  --color-blue-white: #dbf5fb;
  --color-red: #60174f;
  --color-red-solve: #60174f;
  --color-red-white: #fadedc;
  --color-purple: #5c3ba6;
  --color-purple-white: #e6e7ff;
  --color-warning: #f7d060;
  --color-error: #60174f;
  --color-white: #ffffff;
  --color-black: #000;
  --color-background: #f5f5f9;
  --color-info-dark: #7c8894;
  --color-info-darks: #f7d16081;
  --color-light: #848bc82e;
  --color-dark: #363949;
  --color-dark-variant: #677483;
  --card-border-radius: 2rem;
  --border-radius-1: 0.4rem;
  --border-radius-2: 1.2rem;
  --card-padding: 1.8rem;
  --padding-1: 1.2rem;

  --box-shadow: 0px 0px 12px -6px rgba(177, 177, 217, 0.69);

  --hue: 239;
  --bg: hsl(239, 100%, 71%);
  --fg: hsl(239, 100%, 71%);
  --primary: hsl(0, 0%, 100%);
  --trans-dur: 0.3s;
  --font-size: calc(16px + (20 - 16) * (100vw - 320px) / (1280 - 320));
}

.apexcharts-legend-text {
  color: var(--color-dark) !important;
}
.buttonLogout {
  height: 40px;
  background: var(--color-white);
  /* background: var(--color-error); */
  margin-left: 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonLogout:hover {
  height: 40px;
  /* background: var(--color-white); */
  background: var(--color-error);
  margin-left: 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonLogout span {
  color: var(--color-error);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.closeModalButton {
  height: 40px;
  width: 40px;
  background: var(--color-white);
  /* background: var(--color-error); */
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;
  border-radius: 40px;
  border: 1px solid var(--color-error);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.closeModalButton:hover {
  height: 40px;
  width: 40px;
  background: var(--color-error);
  /* background: var(--color-error); */
  margin-left: 20px;
  margin-top: 20px;
  border-radius: 40px;
  border: 1px solid var(--color-error);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.closeModalButton span {
  color: var(--color-error);
  font-size: 25px;
  font-weight: 500;
}
.totalContent {
  /* width: 250px; */
  height: 120px;
  background-color: var(--color-white);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
  position: absolute;
  display: none;
  bottom: 0px;
  right: 300px;
  z-index: 10;
  transition: opacity 0.5s ease-out, width 0.5s ease-out, display 1s ease-out;
  border-left: 10px solid var(--color-error);
}
.closeModalButton:hover span {
  color: var(--color-white);
  font-size: 25px;
  font-weight: 500;
}
.buttonLogout:hover span {
  color: var(--color-white);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
* {
  margin: 0;
  padding: 0;
  outline: 0;
  appearance: none; /* Corrected property value */
  border: 0;
  text-decoration: none;
  box-sizing: border-box;
  transition: background-color 0.5s ease-out, width 0.5s ease-out,
    display 1s ease-out; /* Combined transitions */
}
.alertNotification {
  width: calc(100% - 60px);
  /* height: 50px; */
  margin-top: 20px;
  padding: 10px;
  margin-left: 30px;
  margin-right: 30px !important;
  border: 0.5px solid var(--color-error) !important;
  border-radius: 5px;
  display: flex;
  align-content: center;
  align-items: center;
}
.alertNotification span {
  color: var(--color-error);
}
html {
  font-size: 14px;
}

body {
  width: 100vw;
  height: 100vh;
  font-family: "Poppins", sans-serif;
  font-size: 0.88rem;
  user-select: none;
  overflow: hidden;
  display: flex;
  color: var(--color-dark);
  background-color: var(--color-background);
}

.principaleContent {
  background: red;
  width: 100vw;
  height: 100vh;
  margin: 0;
  display: flex;
  flex-direction: row;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flexNoJustify {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flexNoJustify .fileForm {
  display: flex;
  flex-direction: row;
  margin: 0px;
}
.flexNoJustify .fileForm .input-section {
  width: 250px !important;
}
/* normal left bar */
.lefBar {
  width: 250px;
  /* width: 70px; */
  height: 100vh;
  background: var(--color-primary);
  padding-left: 10px;
  box-shadow: 8px 0px 12px -6px rgba(177, 177, 217, 0.69);
  -webkit-box-shadow: 8px 0px 12px -6px rgba(177, 177, 217, 0.69);
  -moz-box-shadow: 8px 0px 12px -6px rgba(177, 177, 217, 0.69);
  /* box-shadow: 4px -1px 50px 23px rgba(236, 237, 241, 0.75);
      -webkit-box-shadow: 4px -1px 50px 23px rgba(236, 237, 241, 0.75);
      -moz-box-shadow: 4px -1px 50px 23px rgba(236, 237, 241, 0.75); */
}

.lefBar .logoContent {
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  align-content: center;
  background-color: var(--color-white);
  margin-left: -10px;
  margin-bottom: 10px;
}
.lefBar .logoContent .logoImg {
  width: 150px;
  margin-left: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.lefBar .logoContent span {
  font-size: 28px;
  font-weight: 600;
  margin-left: 10px;
  line-height: normal;
  color: var(--color-white);
}
/* mini left bar  */
.lefBarMini {
  /* width: 250px; */
  width: 70px;
  height: 100vh;
  background: var(--color-primary);
  padding-left: 10px;
  box-shadow: 8px 0px 12px -6px rgba(177, 177, 217, 0.69);
  -webkit-box-shadow: 8px 0px 12px -6px rgba(177, 177, 217, 0.69);
  -moz-box-shadow: 8px 0px 12px -6px rgba(177, 177, 217, 0.69);
  /* box-shadow: 4px -1px 50px 23px rgba(236, 237, 241, 0.75);
      -webkit-box-shadow: 4px -1px 50px 23px rgba(236, 237, 241, 0.75);
      -moz-box-shadow: 4px -1px 50px 23px rgba(236, 237, 241, 0.75); */
}

.lefBarMini .logoContent {
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  background-color: var(--color-white);
  align-content: center;
  margin-left: -10px;
  margin-bottom: 10px;
}
.lefBarMini .logoContent .logoImg {
  width: 40px;
  margin-left: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.lefBarMini .logoContent span {
  font-size: 28px;
  font-weight: 600;
  line-height: normal;
  color: #32475c;
}
.contentListe {
  height: calc(100vh - 200px);
  overflow: scroll;
}
.menueGroupe {
  margin-top: 30px;
}
.menueGroupe .titleMenue span {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.75rem;
  margin-left: 10px;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: var(--color-black);
  margin-bottom: 20px;
}

.menueGroupe ul {
  list-style: none;
}
.menueGroupe ul .active {
  height: 44px;
  width: 100%;
  margin-bottom: 5px;
  padding-right: 10px;
  border-right: 5px solid var(--color-black);
}
.menueGroupe ul li {
  height: 44px;
  width: 100%;
  margin-bottom: 5px;
  padding-right: 10px;
}
.modal {
  margin-top: 20px;
}
.modal {
  /* width: 500px; */
  /* height: 700px; */
  /* background-color: #0072dc53; */
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: column;
  z-index: 7;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  padding: 0px;
  margin: 0px;
}
.modal .form {
  width: 100% !important;
  margin: 40px;
  /* height: 700px; */
}
.menueGroupe ul .active .myContent {
  height: 44px;
  background: var(--color-primary-hard);
  border-radius: 5px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.menueGroupe ul .active .myContent:hover {
  height: 44px;
  background: var(--color-primary-hard);
  border-radius: 5px;
  margin-bottom: 5px;
  display: flex;
  width: 100%;
  align-items: center;
}
.menueGroupe ul li .myContent:hover {
  height: 44px;
  background: var(--color-primary-hard);
  border-radius: 5px;
  display: flex;
  align-items: center;
  width: calc(100% - 5px);
  margin-bottom: 5px;
  padding-right: 15px;
}
.menueGroupe ul li .myContent {
  height: 44px;
  border-radius: 5px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.menueGroupe ul .active .myContent .menueText {
  color: var(--color-black);
  overflow: hidden;
  margin-inline-end: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.menueGroupe ul li .myContent .menueText {
  color: var(--color-black);
  overflow: hidden;
  margin-inline-end: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.menueGroupe ul li .myContent .menueIcone {
  color: var(--color-black);
  margin-left: 10px;
  margin-right: 10px;
}
.menueGroupe ul .active .myContent .menueIcone {
  color: var(--color-black);
  margin-left: 10px;
  margin-right: 10px;
}
.centerContent {
  width: calc(100vw - 70px);
  height: 100vh;
  background-color: var(--color-background);
  display: flex;
  flex-direction: column;
}
/* lefBarMini */
.centerContentMini {
  width: calc(100vw - 70px);
  height: 100vh;
  background-color: var(--color-background);
  display: flex;
  flex-direction: column;
}
.headerNavBar {
  height: 80px;
  background: var(--color-white);
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 10px;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
  /* box-shadow: 0px 14px 0px 0px rgba(236,237,241,0.75);
    -webkit-box-shadow: 0px 14px 50px 23px rgba(236,237,241,0.75);
    -moz-box-shadow: 0px 14px 50px 23px rgba(236,237,241,0.75); */
}
.headerNavBar .leftContent {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-left: 20px;
}
.headerNavBar .leftContent .togleMenueButton {
  background: var(--color-white);
  /* border: 0.5px solid var(--color-primary); */
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-right: 20px;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.headerNavBar .leftContent .togleMenueButton:hover {
  background: var(--color-primary-solve);
  /* border: 0.5px solid var(--color-primary); */
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-right: 20px;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}

.headerNavBar .leftContent .togleMenueButton span {
  color: var(--color-primary);
}
.headerNavBar .leftContent .notificationCount {
  background: var(--color-white);
  /* border: 0.5px solid var(--color-primary); */
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  position: relative;
  margin-right: 20px;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.headerNavBar .leftContent .notificationCount span {
  color: var(--color-info-dark);
  position: relative;
}
.headerNavBar .leftContent .notificationCount .patch {
  color: var(--color-white);
  background-color: var(--color-error);
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.headerNavBar .rightContent {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-right: 20px;
}
.headerNavBar .rightContent span {
  text-align: right;
  margin-right: 10px;
}
.elementSpace {
  /* background: var(--color-background); */
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
}
.firstContent {
  /* background: var(--color-background); */
  width: 350px;
  min-height: 300px;
  border-left: 5px solid var(--color-primary);

  margin-top: 20px;
  padding: 10px;
}
.elementSpace .titre {
  color: var(--color-dark);
  font-size: 25px;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 40px !important;
  margin-right: 20px;
  margin-bottom: 20px;
}
.elementSpace .myIcons {
  color: var(--color-error);
  font-size: 15px;
  font-weight: 600;
  margin-right: 10px;
}
.modal .form h4 {
  font-size: 1.5em;
  margin-bottom: 20px;
  margin-left: 30px !important;
}
.list-group li {
  list-style: none;
  border-bottom: 0.5px solid var(--color-dark-variant);
  height: 50px;
  display: flex;
  padding: 10px;
  /* color: var(--color-black); */
  font-size: 15px;
  align-items: center;
  /* justify-content: center; */
}
.headerNavBar .rightContent .profileTexte {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -ms-flex-line-pack: center;
  align-content: flex-end;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-end;
  margin-right: 20px;
  flex-wrap: wrap;
}
.headerNavBar .rightContent .profileTexte .userName {
  font-weight: 600;
  font-size: 1.4rem;
  color: var(--color-dark);
}
.headerNavBar .rightContent img {
  width: 40px;
  height: 40px;
  border-radius: 100%;
}
.content {
  display: flex;
  flex-direction: row;
  padding: 20px;
}
.content .contentLeft {
  height: calc(100vh - 120px);
  margin-right: 10px;
  /* background: var(--color-white); */
  width: 70%;
  overflow: none;
}

.wallet .grid-container {
  display: grid;
  gap: 20px;
  padding-top: 20px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}

.wallet .grid-container .card {
  background-color: white;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}
/* .wallet .grid-container .card .title {

} */
.wallet .grid-container .card .price {
  font-size: 25px !important;
  font-weight: bold;
  color: var(--color-primary);
}

@media (max-width: 600px) {
  .wallet .grid-container {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}
.allHomeContent {
  overflow: scroll !important;
  height: calc(100vh - 120px);
}
.content .allContent {
  /* height: calc(100vh - 120px); */
  background: var(--color-white);
  width: 100%;
  /* overflow: scroll; */
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
  border-radius: 10px;
  padding: 20px;
}
.content .allContent .textPart img {
  width: 500px;
  height: 250px;
  padding: 20px;
}
.content .contentPrincipal {
  height: calc(100vh - 120px);
  background: var(--color-white);
  width: 100%;
  /* overflow: scroll; */
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
  border-radius: 10px;
  padding: 20px;
}
.chartLabelTitle {
  font-weight: 500;
  font-size: 1.4rem;
  color: var(--color-dark);
  /* margin-left: 10px; */
}

.content .contentLeft .graphHystory {
  height: 400px;
  margin-right: 10px;
  background: var(--color-white);
  border-radius: 10px;
  padding: 20px;
  /* margin-top: 20px; */
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
  width: 100%;
}
.content .contentLeft .otherStatGraph {
  height: calc(100% - 420px);
  margin-right: 10px;
  /* background: var(--color-white); */
  border-radius: 10px;
  margin-top: 20px;
  /* box-shadow: var(--box-shadow);
      -webkit-box-shadow: var(--box-shadow);
      -moz-box-shadow: var(--box-shadow); */
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px;
}
.content .contentLeft .contentOtherStatGraph {
  background: var(--color-white);
  border-radius: 10px;
  height: 538px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.content .contentLeft .contentOtherStatGraph .contentDetails {
  background: var(--color-white);
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content .contentLeft .contentOtherStatGraph .contentDetails .leftContent {
  background: var(--color-white);
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  height: 120px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
}

.content .contentLeft .contentOtherStatGraph .price {
  font-size: 10px !important;
  font-weight: 500;
  text-transform: none !important;
  color: var(--color-info-dark);
  margin-bottom: 10px;
}

.content .contentLeft .contentOtherStatGraph .contentDetails .rightContent {
  background: var(--color-white);
  margin-top: 20px;
  margin-bottom: 20px;
  width: 50%;
  height: 120px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
}
.content .contentRight .listCard {
  margin-right: 10px;
  /* background: var(--color-white); */
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

/* gren card */
.content .contentRight .listCard .miniCard {
  background: var(--color-white);
  height: 190px;
  border-radius: 10px;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.content .contentRight .listCard .miniCard .cardIcon {
  background: var(--color-green-white);
  height: 40px;
  width: 40px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
}
.content .contentRight .listCard .miniCard .cardIcon span {
  color: var(--color-success);
}
.content .contentRight .listCard .miniCard .cardIconBlue {
  background: var(--color-blue-white);
  height: 40px;
  width: 40px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
}
.content .contentRight .listCard .miniCard .cardIconBlue span {
  color: var(--color-blue);
}
.content .contentRight .listCard .miniCard .cardIconRed {
  background: var(--color-red-white);
  height: 40px;
  width: 40px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
}
.content .contentRight .listCard .miniCard .cardIconRed span {
  color: var(--color-red);
}
.content .contentRight .listCard .miniCard .cardIconPurple {
  background: var(--color-purple-white);
  height: 40px;
  width: 40px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
}
.content .contentRight .listCard .miniCard .cardIconPurple span {
  color: var(--color-purple);
}
.content .contentRight .listCard .miniCard .cardTitle {
  color: var(--color-info-dark);
  line-height: 1.3125rem;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0094rem;
  padding-top: 1.5rem;
  padding-left: 1.5rem;
  text-transform: none;
}
.content .contentRight .listCard .miniCard .cardAmount {
  color: var(--color-info-dark);
  text-transform: none;
  font-size: 1rem !important;
  font-weight: 500;
  line-height: 2rem;
  letter-spacing: normal !important;
  padding-top: 0.5rem;
  padding-left: 1.5rem;
}
.content .contentRight .listCard .miniCard .cardRate {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  padding-top: 0.7rem;
  padding-left: 1.5rem;
}
.content .contentRight .listCard .miniCard .cardRate {
  color: var(--color-success);
}
.content .contentRight .listCard .miniCard .cardRateRed {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  padding-top: 0.7rem;
  padding-left: 1.5rem;
}
.content .contentRight .listCard .miniCard .cardRateRed {
  color: var(--color-red);
}

/* gren card */
.content .contentRight .profiHystory {
  height: 200px;
  margin-right: 10px;
  background: var(--color-white);
  border-radius: 10px;

  margin-top: 20px;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
  width: 100%;
}
.content .contentLeft .otherStatGraph {
  height: 538px;
  margin-right: 10px;
  background: var(--color-white);
  border-radius: 10px;
  margin-top: 20px;
  /* padding: 20px; */
  display: flex;
  flex-direction: column;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
  width: 100%;
}
.content .contentRight .transactionHystory {
  height: 538px;
  margin-right: 10px;
  background: var(--color-white);
  border-radius: 10px;
  margin-top: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
  width: 100%;
}
.buttonRow {
  display: flex;
  flex-direction: row; /* par défaut, donc optionnel */
  justify-content: space-between;
  align-items: center; /* facultatif : aligne les éléments verticalement */
  width: 100%; /* ou une autre largeur fixe */
}

.content .contentRight {
  height: calc(100vh - 120px);
  /* background: var(--color-white); */
  margin-left: 10px;
  width: 30%;
  overflow: none;
}
a {
  color: var(--color-dark);
}

img {
  display: block;
  width: 100%;
  object-fit: cover;
}

h1 {
  font-weight: 800;
  font-size: 1.8rem;
}

h2 {
  font-weight: 600;
  font-size: 1.4rem;
}

h3 {
  font-weight: 500;
  font-size: 0.87rem;
}

small {
  font-size: 0.76rem;
}

p {
  color: var(--color-dark-variant);
}

b {
  color: var(--color-dark);
}

.text-muted {
  color: var(--color-info-dark);
}

.primary {
  color: var(--color-primary);
}

.danger {
  color: var(--color-danger);
}

.success {
  color: var(--color-success);
}

.warning {
  color: var(--color-warning);
}
.separation {
  width: calc(100% - 40px);
  margin: 20px;
  height: 0.5px;
  background-color: #7c8894;
}
.container {
  display: grid;
  width: 96%;
  margin: 0 auto;
  gap: 1.8rem;
  grid-template-columns: 12rem auto 23rem;
}

.contentLists {
  display: flex;
  flex-direction: column;
  /* height: 800px; */
  height: calc(100vh - 300px);
  width: 100%;
  overflow: scroll;
}
.contentLists .contentListeTable {
  background: var(--color-white);
  width: 100%;
  /* height: 100%; */

  margin-top: 20px;
  transition: all 0.3s ease;
  table-layout: fixed;
}

.contentLists .contentListeTable thead {
  background: var(--color-white);
  height: 50px;
  text-align: left;
  position: sticky;
  padding: 10px;
  top: 0;
  /* z-index: 3; */
}
.contentLists .contentListeTable thead tr th:first-child {
  padding: 10px;
  /* background: var(--color-white); */
  border-top-left-radius: 10px;
}
.contentLists .contentListeTableAction thead tr th:first-child {
  padding: 10px;
  /* background: var(--color-white); */
  border-top-left-radius: 10px;
  width: 80px !important;
}
.contentLists .contentListeTable thead tr th:last-child {
  padding: 10px;
  color: var(--color-primary);
  border-top-right-radius: 10px;
}
.contentLists .contentListeTable thead tr th {
  padding: 10px;
  color: var(--color-black) !important;
  background: var(--color-primary-solve);
}
.contentLists .contentListeTable tbody .noActive:hover td:first-child {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  /* text-align: center; */
  /* display: flex;
  align-items: center;
  justify-content: center; */
  border-left: 5px solid var(--color-primary-solve);
}
.contentLists .contentListeTable tbody .active td:first-child {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  border-left: 5px solid var(--color-primary) !important;
}
.contentLists .contentListeTable tbody tr:nth-child(even) {
  background-color: var(--color-background);
}
.contentLists .contentListeTable tbody tr {
  height: 50px !important;
}
.contentLists .contentListeTable tbody tr td {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  /* background: var(--color-white); */
  height: 50px !important;
  color: var(--color-info-dark);
  font-size: 12px;
  font-weight: 500;
  font-size: 0.88rem !important;
}

.contentLists .contentListeTable tbody tr td .cardRate {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  color: var(--color-success);
  font-size: 0.88rem !important;
  font-weight: 500;
  /* padding-top: 0.7rem; */
  /* padding-left: 1.5rem; */
}
.contentLists .contentListeTable tbody tr td .cardRateRed {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  color: var(--color-red);
  /* padding-top: 0.7rem; */
  /* padding-left: 1.5rem; */
}
.contentLists .contentListeTable tbody tr td:first-child {
}
.contentLists .contentListeTable .imgeProduct {
  background: var(--color-primary-solve);
  height: 40px;
  width: 40px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-top: 5px;
  margin-right: 5px;
}
.contentLists .contentListeTable .imgeProduct span {
  color: var(--color-primary);
}
.contentLists .contentListeTable .nameContent {
  display: flex;
  flex-direction: column;
}
.contentLists .contentListeTable .nameContent .productTitle {
  color: var(--color-info-dark);
  font-size: 12px;
  font-weight: 600;
}
.contentLists .contentListeTable .nameContent .productType {
  color: var(--color-info-dark);
  font-size: 10px;
  margin-top: 5px;
}
.rowElement {
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
  margin-bottom: 10px;
}
.rowElement span:first-child {
  color: var(--color-success);
}
.rowElement span:last-child {
  color: var(--color-red);
}
.modaleContentSecond {
  width: 0px;
  height: 100vh;
  background: var(--color-white);
  position: absolute;
  top: 0;
  overflow: scroll;
  right: 0;
  z-index: 10;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.modaleContent {
  width: 0px;
  height: 100vh;
  background: var(--color-white);
  position: absolute;
  overflow: scroll;
  top: 0;
  right: 0;
  z-index: 5;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonClose {
  height: 40px;
  background: var(--color-white);
  /* background: var(--color-error); */
  border-radius: 5px;
  width: calc(100%-40px);
  display: flex;
  align-items: center;
  margin: 20px;
  justify-content: center;
  border: 1px solid var(--color-error);
  text-align: center;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonClose:hover {
  height: 40px;
  /* background: var(--color-white); */
  background: var(--color-error);
  margin-left: 20px;
  border-radius: 5px;
  width: calc(100%-40px);
  margin: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonClose span {
  color: var(--color-error);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.buttonDoneSimulate {
  height: 40px !important;
  background: var(--color-red) !important;
  /* background: var(--color-error); */
  border-radius: 5px !important;
  width: 240px;
  display: flex;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 10px;
  justify-content: center;
  border: 1px solid var(--color-red) !important;
  text-align: center;
  box-shadow: var(--box-shadow) !important;
  -webkit-box-shadow: var(--box-shadow) !important;
  -moz-box-shadow: var(--box-shadow) !important;
}
.buttonDoneSimulate:hover {
  height: 40px;
  /* background: var(--color-white); */
  background: var(--color-primary-hard) !important;
  /* margin-left: 20px !important; */
  border-radius: 5px !important;
  width: 240px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid var(--color-primary-hard) !important;
  box-shadow: var(--box-shadow) !important;
  -webkit-box-shadow: var(--box-shadow) !important;
  -moz-box-shadow: var(--box-shadow) !important;
}
/* .buttonDoneSimulate:hover {
  height: 40px;
  background: var(--color-primary-hard) !important;
  margin-left: 20px !important;
  border-radius: 5px !important;
  width: calc(100%-40px) !important;
  margin: 30px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid var(--color-primary-hard) !important;
  box-shadow: var(--box-shadow) !important;
  -webkit-box-shadow: var(--box-shadow) !important;
  -moz-box-shadow: var(--box-shadow) !important;
} */
.buttonDoneSimulate span {
  color: var(--color-white) !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  margin-left: 10px;
  margin-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.buttonDone {
  height: 40px;
  background: var(--color-primary) !important;
  /* background: var(--color-error); */
  border-radius: 5px;
  /* width: 250px;  */
  display: flex;
  align-items: center;
  margin: 30px;
  justify-content: center;
  border: 1px solid var(--color-primary);
  text-align: center;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonDone:hover {
  height: 40px;
  /* background: var(--color-white); */
  background: var(--color-primary-hard);
  margin-left: 20px;
  border-radius: 5px;
  width: calc(100%-40px);
  margin: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid var(--color-primary-hard);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonDone span {
  color: var(--color-black);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}







.buttonDoneDark {
  height: 40px;
  background: var(--color-red) !important;
  /* background: var(--color-error); */
  border-radius: 5px;
  /* width: 250px;  */
  display: flex;
  align-items: center;
  margin: 30px;
  justify-content: center;
  border: 1px solid var(--color-red-hard);
  text-align: center;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonDoneDark:hover {
  height: 40px;
  /* background: var(--color-white); */
  background: var(--color-red);
  margin-left: 20px;
  border-radius: 5px;
  width: calc(100%-40px);
  margin: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 1px solid var(--color-red-hard);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonDoneDark span {
  color: var(--color-white);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}




.disabled {
  /* height: 40px; */
  background: var(--color-primary-solve);
  /* background: var(--color-error); */
  /* border-radius: 5px; */
  /* width: 300px; */
}
.disabledError {
  /* height: 40px; */
  background: var(--color-error);
  color: var(--color-white);
  font-weight: 900;
  /* background: var(--color-error); */
  /* border-radius: 5px; */
  /* width: 300px; */
}
.buttonDisabled {
  height: 40px;
  background: var(--color-primary-solve);
  margin-left: 20px;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  max-width: 300px;
  margin: 10px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-primary-solve);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonDisabled:hover {
  height: 40px;
  background: var(--color-primary-solve);
  margin-left: 20px;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  max-width: 300px;
  margin: 10px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-primary-solve);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonDisabled span {
  color: var(--color-black);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;
}

.buttonDelete {
  height: 40px;
  background: var(--color-red);
  /* background: var(--color-error); */
  border-radius: 5px;
  width: 300px;
  display: flex;
  align-items: center;
  margin: 10px;
  margin-top: 20px;
  justify-content: center;
  border: 1px solid var(--color-red);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonDelete:hover {
  height: 40px;
  /* background: var(--color-white); */
  background: var(--color-primary-hard);
  margin-left: 20px;
  border-radius: 5px;
  width: 300px;
  margin: 10px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-primary-hard);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonDelete span {
  color: var(--color-white);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;
}

.buttonAdd {
  height: 40px;
  background: var(--color-primary);
  /* background: var(--color-error); */
  border-radius: 5px;
  max-width: 300px;
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0px;
  margin-top: 20px;
  justify-content: center;
  border: 1px solid var(--color-primary);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonAdd:hover {
  height: 40px;
  /* background: var(--color-white); */
  background: var(--color-primary-hard);
  margin-left: 20px;
  border-radius: 5px;
  max-width: 300px;
  width: 100%;
  margin: 0px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-primary-hard);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonAdd span {
  color: var(--color-black);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;
}

.buttonAddSecond {
  height: 40px;
  background: var(--color-white);
  /* background: var(--color-error); */
  border-radius: 5px;
  width: 300px;
  display: flex;
  align-items: center;
  margin: 10px;
  margin-top: 20px;
  justify-content: center;
  border: 1px solid var(--color-primary);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonAddSecond:hover {
  height: 40px;
  /* background: var(--color-white); */
  background: var(--color-primary-hard);
  margin-left: 20px;
  border-radius: 5px;
  width: 300px;
  margin: 10px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--color-primary-hard);
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.buttonAddSecond span {
  color: var(--color-black);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;
}

.buttonAddSecond:hover span {
  color: var(--color-white);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;
}
.rubriqueTitle {
  color: var(--color-dark);
  font-size: 25px;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 40px !important;
  margin-right: 20px;
  margin-bottom: 20px;
}
.exportHead {
  background: var(--color-primary);
  color: var(--color-white);
}
.formTitle {
  color: var(--color-dark);
  font-size: 25px;
  font-weight: 600;
  margin-left: 30px;
  margin-top: 40px !important;
  margin-right: 20px;
  margin-bottom: 20px;
}
.buttonClose:hover span {
  color: var(--color-white);
  font-size: 15px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.nameContentButton {
  height: 50px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  align-content: center;
  position: relative;
}
.nameContentButton .tableButton {
  /* border: 0.5px solid var(--color-primary); */
  width: 40px;
  height: 40px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
}

.tableButton .toolTip {
  content: attr(title);
  position: absolute;
  background-color: var(--color-primary);
  color: #fff !important;
  /* width: 100px; */
  height: 30px;
  padding: 5px;
  border-radius: 5px;
  white-space: nowrap;
  z-index: 1;
  top: 40px;
  /* top: 100%; */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.tableButton:hover .toolTip {
  opacity: 0.5;
}
.tabContent {
  width: 100%;
  height: 60px;
  background: var(--color-white);
  display: flex;
  align-content: center;
  align-items: center;
  border-bottom: 0.5px solid var(--color-info-dark);
}
.tabContent .tabElement {
  height: 60px;
  /* width: 120px; */
  background: var(--color-white);
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  color: var(--color-info-dark);
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: 0.5px solid var(--color-info-dark);
}
.tabContent .active {
  height: 60px;
  /* width: 120px; */
  background: var(--color-white);
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: bold;
  color: var(--color-primary);
  border-bottom: 5px solid var(--color-primary);
}
.tabContent .tabElement span {
  margin-right: 20px;
}
.tabElementContent {
  display: none;
  opacity: 0;
  transition: opacity 5s ease-out; /* Ajoutez une transition d'opacité */
}

.tabElementContent.active {
  display: block;
  opacity: 1;
  transition: opacity 5s ease-out;
}
/* formuleaire style */

.input-section {
  /* width: 100%; Pour s'assurer que les enfants occupent toute la largeur du parent */
}
.fileFormProfile {
  display: grid;
  grid-gap: 10px;
  margin: 20px;
  grid-template-columns: repeat(3, 1fr) !important;
}
.fileFormProfileUnique {
  display: flex;
  flex-direction: column;
}
/* .fileFormProfile .input-section:first-child{
   margin-left: 0px;
   margin-right: 10px;

  } */
.fileFormProfile .input-section:nth-child() {
  margin-left: 10px;
  margin-right: 10px;
}
.fileFormProfile .input-sections {
  margin-left: 10px;
  margin-right: 0px;
}
.fileFormProfile .input-section {
  margin-right: 10px;
  margin-left: 10px;
}


.fileForm {
  display: grid;
  grid-gap: 10px;
  margin: 20px;
  grid-template-columns: repeat(1, 1fr) !important;
  /* width: 100%; */
}
.fileForm .input-section:nth-child() {
  margin-left: 10px;
  margin-right: 10px;
}
.fileForm .input-sections {
  margin-left: 10px;
  margin-right: 0px;
}
.fileForm .input-section {
  margin-right: 10px;
  margin-left: 10px;
}
.fileForm .input-section img {
  width: 100%;
  height: 200px;
}
.fileFormSecond {
  display: grid;
  grid-gap: 10px;
  margin: 20px;
}
.fileFormSecond .input-section:nth-child() {
  margin-left: 10px;
  margin-right: 10px;
}
.fileFormSecond .input-sections {
  margin-left: 10px;
  margin-right: 0px;
}
.fileFormSecond .input-section {
  margin-right: 10px;
  margin-left: 10px;
}
.fileFormOne {
  display: grid;
  grid-gap: 10px;
  margin: 20px;

  /* width: 100%; */
}
.fileFormOne .input-section:nth-child() {
  margin-left: 10px;
  margin-right: 10px;
}
.fileFormOne .input-sections {
  margin-left: 10px;
  margin-right: 0px;
}
.fileFormOne .input-section {
  margin-right: 10px;
  margin-left: 10px;
}
.listeDynamicContent {
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
  width: calc(100% - 40px);
}
.listeDynamicContent .addButton {
  background: var(--color-success);
  height: 40px;
  width: 150px;
  /* background: var(--color-error); */
  margin-left: 20px;
  margin-top: 20px;
  border-radius: 10px;
  border: 1px solid var(--color-success);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.listeDynamicContent .addButton span {
  color: var(--color-white);
  /* font-size: 25px;
  font-weight: 500; */
}
.listeDynamicContent .addButton:hover {
  background: var(--color-success-dark);
  border: 1px solid var(--color-success-dark);
}

.listeDynamicContentSecond {
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  align-content: flex-start;
  width: calc(100% - 40px);
}
.listeDynamicContentSecond .addButton {
  background: var(--color-success);
  height: 40px;
  width: 40px;
  /* background: var(--color-error); */
  margin-left: 20px;
  margin-top: 20px;
  border-radius: 40px;
  border: 1px solid var(--color-success);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: var(--box-shadow);
  -webkit-box-shadow: var(--box-shadow);
  -moz-box-shadow: var(--box-shadow);
}
.listeDynamicContentSecond .addButton span {
  color: var(--color-white);
  /* font-size: 25px;
  font-weight: 500; */
}
.listeDynamicContentSecond .addButton:hover {
  background: var(--color-success-dark);
  border: 1px solid var(--color-success-dark);
}

.listeDynamicContent .closeButton span {
  color: var(--color-error);
  font-size: 25px;
  font-weight: 500;
}
.listeDynamicContent .closeButton:hover span {
  color: var(--color-white);
  font-size: 25px;
  font-weight: 500;
}
.input-section input,
.input-section select,
.forme button {
  display: block;
  outline: none;
  width: 100%;
  height: 58px;
  padding: 1.1em 0.5em;
  border: 1.5px solid #d0d0d0;
  border-radius: 0.3em;
}
/* .input-section .v-autocomplete {
  display: block;
  outline: none;
  width: 100%;
  padding: 0.9em 0.4em;
  border-radius: 0.3em;
} */
.autocomplete-options {
  position: absolute;
  width: 80%;
  /* height: 200px; */
  padding: 1.1em 0.5em;
  background: var(--color-primary);
  border: 1.5px solid #d0d0d0;
  border-radius: 0.3em;
  max-height: 150px;
  overflow-y: auto;
  color: var(--color-white);
}
.autocomplete-options div {
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
  border-bottom: 0.5px solid var(--color-white);
}
.isDisabled {
  background-color: var(--color-info-darks) !important;
}
.required-color {
  color: #ff4747;
}
/* .v-autocomplete input {
  outline: none;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  border-radius: 5px;
  outline: none;
  border: none;
  height: auto !important;
  margin: 0px !important;
  padding: 0px !important;
} */
.v-text-field__details {
  display: -webkit-box;
  display: -ms-flexbox;
  display: none;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
  max-width: 100%;
  min-height: 14px;
  overflow: hidden;
}
.v-text-field--rounded > .v-input__control > .v-input__slot {
  padding: 0px !important;
}
.v-application ul,
.v-application ol {
  padding-left: 0px !important;
}
.v-application--is-ltr .v-text-field .v-input__append-inner {
  margin-left: auto;
  padding-left: 4px;
  display: none;
}
/* .input-field input,
select,
.v-autocomplete {
  outline: none;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  border-radius: 5px;
  border: 1px solid #aaa;
  padding: 0 15px;
  height: auto !important;
  margin: 8px 0;
} */
.v-autocomplete {
  outline: none;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  border-radius: 5px;
  border: 1px solid #aaa;
  padding: 0 15px;
  height: auto !important;
  margin: 0px !important;
}
.input-section .v-autocomplete {
  display: block;
  outline: none;
  width: 100%;
  height: 58px !important;
  /* padding: 0.9em 0.4em; */
  /* border: 1.5px solid #d0d0d0; */
  border-radius: 0.3em;
}
.v-input__slot {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 8px;
  min-height: 58px !important;
  position: relative;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  -webkit-transition-property: height, min-height;
  transition-property: height, min-height;
  width: 100%;
}
.input-field input[data-v-0cc976aa],
select[data-v-0cc976aa],
.v-autocomplete[data-v-0cc976aa] {
  outline: none;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  margin-top: 10px !important;
  border-radius: 5px;
  border: 1px solid #aaa;
  padding-top: 10px !important;
  padding-left: 5px !important;
  height: 48px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.v-autocomplete input {
  outline: none;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  border-radius: 5px;
  outline: none;
  border: none;
  /* padding: 0 15px; */
  height: 48px !important;
  margin: 0px !important;
  padding: 0px !important;
}
.v-list-item__action,
.v-list-item__avatar,
.v-list-item__icon {
  display: inline-flex;
  min-width: 0px !important;
}
.input-field input,
select,
.v-autocomplete {
  outline: none;
  font-size: 14px;
  font-weight: 400;
  color: #333;
  border-radius: 5px;
  border: 1px solid #aaa;
  padding: 0 15px;
  height: auto !important;
  margin: 8px 0;
}

/*loading*/
.preloader {
  text-align: center;

  width: 100%;
  background-color: transparent;
  border: none;
}
.preloader__text {
  position: relative;
  height: 1.5em;
}
.preloader__msg {
  animation: msg 0.3s 13.7s linear forwards;
  position: absolute;
  width: 100%;
}
.preloader__msg--last {
  animation-direction: reverse;
  animation-delay: 14s;
  visibility: hidden;
}
.cart {
  display: block;
  margin: 0 auto 1.5em auto;
  width: 8em;
  height: 8em;
}
.cart__lines,
.cart__top,
.cart__wheel1,
.cart__wheel2,
.cart__wheel-stroke {
  animation: cartLines 2s ease-in-out infinite;
}
.cart__lines {
  stroke: var(--primary);
}
.cart__top {
  animation-name: cartTop;
}
.cart__wheel1 {
  animation-name: cartWheel1;
  transform: rotate(-0.25turn);
  transform-origin: 43px 111px;
}
.cart__wheel2 {
  animation-name: cartWheel2;
  transform: rotate(0.25turn);
  transform-origin: 102px 111px;
}
.cart__wheel-stroke {
  animation-name: cartWheelStroke;
}
.cart__track {
  stroke: hsla(var(--hue), 10%, 10%, 0.1);
  transition: stroke var(--trans-dur);
}

/* Dark theme */
@media (prefers-color-scheme: dark) {
  :root {
    --bg: hsl(var(--hue), 10%, 10%);
    --fg: hsl(var(--hue), 10%, 90%);
  }
  .cart__track {
    stroke: hsla(var(--hue), 10%, 90%, 0.1);
  }
}

/* Animations */
@keyframes msg {
  from {
    opacity: 1;
    visibility: visible;
  }
  99.9% {
    opacity: 0;
    visibility: visible;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
}
@keyframes cartLines {
  from,
  to {
    opacity: 0;
  }
  8%,
  92% {
    opacity: 1;
  }
}
@keyframes cartTop {
  from {
    stroke-dashoffset: -338;
  }
  50% {
    stroke-dashoffset: 0;
  }
  to {
    stroke-dashoffset: 338;
  }
}
@keyframes cartWheel1 {
  from {
    transform: rotate(-0.25turn);
  }
  to {
    transform: rotate(2.75turn);
  }
}
@keyframes cartWheel2 {
  from {
    transform: rotate(0.25turn);
  }
  to {
    transform: rotate(3.25turn);
  }
}
@keyframes cartWheelStroke {
  from,
  to {
    stroke-dashoffset: 81.68;
  }
  50% {
    stroke-dashoffset: 40.84;
  }
}
.v-dialog {
  border-radius: 4px;
  margin: 24px;
  overflow-y: auto;
  pointer-events: auto;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  z-index: inherit;
  outline: none;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
@media only screen and (max-width: 600px) {
  .lefBarMini .contentListe {
    height: calc(100vh - 80px);
    overflow: scroll;
  }
  .lefBar .contentListe {
    height: calc(100vh - 200px);
    overflow: scroll;
  }
  .headerNavBar .leftContent .notificationCount {
    display: none;
  }
  .headerNavBar .rightContent .profileTexte {
    display: none;
  }
  .headerNavBar .rightContent img {
    display: none;
  }
  .content .allContent .textPart img {
    width: 100%;
  }
  .content {
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 100%;
  }

  .content .contentLeft {
    width: 100% !important;
    height: 100%;
    margin-right: 0px;
    /* background: var(--color-white); */

    overflow-y: scroll;
  }
  .content .contentRight {
    width: 100% !important;
    height: 100%;
    /* background: var(--color-white); */
    margin-left: 0px;
    margin-top: 20px;
    overflow-y: scroll;
  }
  .headerNavBar {
    height: 80px;
    background: var(--color-white);
    width: calc(100% - 40px);
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
    display: flex;
    z-index: 10;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 10px;
    /* box-shadow: 0 1px 5px 0 rgba(41, 85, 115, 0.21); */
  }
  .content .allContent .textPart img {
    padding: 0px;
  }
  .hide {
    display: none !important;
  }
  .content .allContent .textPart h1 {
    font-size: 15px;
    margin-top: 10px;
    margin-left: 0px;
  }
  /* .content .contentLeft .otherStatGraph {
  display: none
} */
  .contentLists .contentListeTable thead tr th {
    width: 200px !important;
  }
  .contentLists .contentListeTable thead tr th:first-child {
    width: 80px !important;
  }
  .rowElement {
    display: flex;
    margin-top: 10px;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .content .contentRight .listCard .miniCard {
    background: var(--color-white);
    height: 220px;
    border-radius: 10px;
    box-shadow: var(--box-shadow);
    -webkit-box-shadow: var(--box-shadow);
    -moz-box-shadow: var(--box-shadow);
  }
  .tabContent .tabElement span {
    display: none;
  }
  .myContent {
    width: 100%;
    overflow-x: scroll;
  }
  .tabContent {
    width: max-content;
    height: 60px;
    overflow-x: scroll;
    overflow-y: hidden;
    background: var(--color-white);
    display: flex;
    align-content: center;
    align-items: center;
    border-bottom: 0.5px solid var(--color-info-dark);
  }
  .tabContent .tabElement {
    text-overflow: ellipsis;
  }
  .buttonAdd {
    height: 60px;
    background: var(--color-primary);
    /* background: var(--color-error); */
    border-radius: 5px;
    width: 100%;
    display: flex;
    align-items: center;
    margin: 0px;
    margin-bottom: 10px;

    margin-top: 20px;
    justify-content: center;
    border: 1px solid var(--color-primary);
    box-shadow: var(--box-shadow);
    -webkit-box-shadow: var(--box-shadow);
    -moz-box-shadow: var(--box-shadow);
  }
  .buttonAdd:hover {
    height: 60px;
    margin-bottom: 10px;
  }
  .buttonDisabled {
    height: 60px;
    background: var(--color-primary-solve);
    margin-left: 20px;
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    margin: 0px;
    margin-bottom: 10px;

    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--color-primary-solve);
    box-shadow: var(--box-shadow);
    -webkit-box-shadow: var(--box-shadow);
    -moz-box-shadow: var(--box-shadow);
  }
  .buttonDisabled:hover {
    height: 60px;
    margin-bottom: 10px;
  }
  .flex {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
  }
  .flexNoJustify {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
  }
  .flexNoJustify .fileForm {
    display: flex;
    flex-direction: column;
    margin: 0px;
  }
  .flexNoJustify .fileForm .input-section {
    width: 100% !important;
    margin-left: 0px;
  }
  .modaleContent {
    width: 0px;
    height: 100vh;
    background: var(--color-white);
    position: absolute;
    overflow: scroll;
    top: 0;
    right: 0;
    z-index: 11;
    box-shadow: var(--box-shadow);
    -webkit-box-shadow: var(--box-shadow);
    -moz-box-shadow: var(--box-shadow);
  }
}

@media only screen and (max-width: 1000px) {
  .lefBarMini .contentListe {
    height: calc(100vh - 80px);
    overflow: scroll;
  }
  .lefBar .contentListe {
    height: calc(100vh - 200px);
    overflow: scroll;
  }
  .headerNavBar .leftContent .notificationCount {
    display: none;
  }
  .headerNavBar .rightContent .profileTexte {
    display: none;
  }
  .headerNavBar .rightContent img {
    display: none;
  }
  .content .allContent .textPart img {
    width: 100%;
    max-width: 250px;
  }
  .content {
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 100%;
  }

  .content .contentLeft {
    width: 100% !important;
    height: 100%;
    margin-right: 0px;
    /* background: var(--color-white); */

    overflow-y: scroll;
  }
  .content .contentRight {
    width: 100% !important;
    height: 100%;
    /* background: var(--color-white); */
    margin-left: 0px;
    margin-top: 20px;
    overflow-y: scroll;
  }
  .headerNavBar {
    height: 80px;
    background: var(--color-white);
    width: calc(100% - 40px);
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
    display: flex;
    z-index: 10;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 10px;
    /* box-shadow: 0 1px 5px 0 rgba(41, 85, 115, 0.21); */
  }
  .content .allContent .textPart img {
    padding: 0px;
  }
  .hide {
    display: none !important;
  }
  .content .allContent .textPart h1 {
    font-size: 15px;
    margin-top: 10px;
    margin-left: 0px;
  }
  /* .content .contentLeft .otherStatGraph {
  display: none
} */
  .contentLists .contentListeTable thead tr th {
    width: 200px !important;
  }
  .contentLists .contentListeTable thead tr th:first-child {
    width: 80px !important;
  }
  .rowElement {
    display: flex;
    margin-top: 10px;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .content .contentRight .listCard .miniCard {
    background: var(--color-white);
    height: 220px;
    border-radius: 10px;
    box-shadow: var(--box-shadow);
    -webkit-box-shadow: var(--box-shadow);
    -moz-box-shadow: var(--box-shadow);
  }
  .tabContent .tabElement span {
    display: none;
  }
  .myContent {
    width: 100%;
    overflow-x: scroll;
  }
  .tabContent {
    width: max-content;
    height: 60px;
    overflow-x: scroll;
    overflow-y: hidden;
    background: var(--color-white);
    display: flex;
    align-content: center;
    align-items: center;
    border-bottom: 0.5px solid var(--color-info-dark);
  }
  .tabContent .tabElement {
    text-overflow: ellipsis;
  }
  .buttonAdd {
    height: 60px;
    background: var(--color-primary);
    /* background: var(--color-error); */
    border-radius: 5px;
    width: 100%;
    display: flex;
    align-items: center;
    margin: 0px;
    margin-bottom: 10px;

    margin-top: 20px;
    justify-content: center;
    border: 1px solid var(--color-primary);
    box-shadow: var(--box-shadow);
    -webkit-box-shadow: var(--box-shadow);
    -moz-box-shadow: var(--box-shadow);
  }
  .buttonAdd:hover {
    height: 60px;
    margin-bottom: 10px;
  }
  .buttonDisabled {
    height: 60px;
    background: var(--color-primary-solve);
    margin-left: 20px;
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    margin: 0px;
    margin-bottom: 10px;

    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--color-primary-solve);
    box-shadow: var(--box-shadow);
    -webkit-box-shadow: var(--box-shadow);
    -moz-box-shadow: var(--box-shadow);
  }
  .buttonDisabled:hover {
    height: 60px;
    margin-bottom: 10px;
  }
  .flex {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
  }
  .flexNoJustify {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
  }
  .flexNoJustify .fileForm {
    display: flex;
    flex-direction: column;
    margin: 0px;
  }
  .flexNoJustify .fileForm .input-section {
    width: 100% !important;
    margin-left: 0px;
  }
  .modaleContent {
    width: 0px;
    height: 100vh;
    background: var(--color-white);
    position: absolute;
    overflow: scroll;
    top: 0;
    right: 0;
    z-index: 11;
    box-shadow: var(--box-shadow);
    -webkit-box-shadow: var(--box-shadow);
    -moz-box-shadow: var(--box-shadow);
  }
}
</style>

